// Loads the Matterport Showcase Embed SDK (ES6 bootstrap) and returns its
// `connect` function. The applicationKey MUST be on the bootstrap URL so the
// SDK can resolve its version — omitting it triggers the "invalid version" error.
// Docs: https://matterport.github.io/developer-docs/embed-sdk/

const BOOTSTRAP = "https://api.matterport.com/sdk/bootstrap/3.0.0-0-g0517b8d76c/sdk.es6.js";

// Native dynamic import hidden from the bundler so webpack never rewrites the
// external URL. Returns the module's live `connect`.
const nativeImport = new Function("url", "return import(url)");

const cache = {};

export async function getMpConnect(sdkKey) {
  const key = (sdkKey || "").trim();
  if (!key) throw new Error("Missing Matterport SDK key");
  if (cache[key]) return cache[key];
  const url = `${BOOTSTRAP}?applicationKey=${encodeURIComponent(key)}`;
  const mod = await nativeImport(url);
  const connect = mod.connect || mod.default?.connect;
  if (typeof connect !== "function") throw new Error("Matterport SDK loaded but connect() is unavailable");
  cache[key] = connect;
  return connect;
}
